<template>
  <div class="serviceNewV2">
    <!-- 标签展示 -->

    <div class="serviceNewV2-top">
      <div
        :style="{ height: heightSize, overflow: 'hidden' }"
        :class="{ 'ServeList-list': true, 'ServeList-listt': true }"
      >
        <div
          :class="{ 'z-category': true, 'is-dark': true }"
          :style="{ margin: '0px', padding: index == 0 ? '6px 0' : '4px 0' }"
          v-for="(item, index) in serviceTagList"
          :key="item.id"
          :ref="'container' + index"
          :id="'container' + index"
        >
          <div class="z-category-container">
            <div>
              <button
                :class="{
                  'z-category-item': true,
                  'is-active': selectAllId.indexOf(item.id) != -1,
                }"
                @click="handleCheckAll(item.id, item.labelList)"
              >
                {{ '全部' + item.taggingName }}
              </button>
            </div>
            <div style="flex: 1;">
              <button
                v-for="item1 in item.labelList"
                :title="item1.labelName"
                :key="item1.id"
                :class="{
                  'z-category-item': true,
                  'is-active': selectD.indexOf(item1.id) != -1,
                }"
                @click="handleCheck(item1.id, item.id, item.labelList.length)"
              >
                {{ item1.labelName }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 20px;" v-if="serviceTagList.length == 1"></div>
    <div
      class="serveList-more"
      @click="moreFilter"
      v-if="serviceTagList.length !== 1"
    >
      <div v-if="more1" style="position: relative;">
        <img
          src="@/assets/Service/juxing.svg"
          alt=""
          width="150px"
          height="48px"
        />
        <span>更多筛选 <i class="el-icon-d-arrow-right"></i></span>
      </div>
      <div v-else style="position: relative;">
        <img
          src="@/assets/Service/juxing.svg"
          alt=""
          width="150px"
          height="48px"
        />
        <span>收起筛选 <i class="el-icon-d-arrow-right i"></i></span>
      </div>
    </div>
    <div class="ServeList-container">
      <!-- 最近使用/推荐服务 -->
      <div
        v-if="serveList && serveList.length > 0"
        class="serviceNewV2-content"
        :style="{ display: showTuiF ? 'none' : 'flex' }"
      >
        <div :class="{ 'serviceNewV2-content-top': true, doubleStyle: double }">
          <div class="serviceNewV2_text" style="height: 100%; float: left;">
            {{ serveName }}<span class="showMaoH">:</span>
          </div>
          <div class="serviceNewV2_list" style="float: left;">
            <MiniApp
              style="margin-top: 10px;"
              v-for="item in serveList"
              :key="item.id"
              type="recently"
              :name="item.serviceName"
              :data="item"
              :serveUrl="serveUrl"
              openApi
            ></MiniApp>
          </div>
          <div style="float: left;">
            <div class="deleteIcon" @click="deletedTui">
              <i class="el-icon-close"></i>
            </div>
            <div
              class="deleteIcon textMore"
              @mouseenter="showMoreIcon = true"
              @mouseleave="showMoreIcon = false"
              v-if="serveListFirst.length > 0"
            >
              更多
              <i
                style="font-size: 12px; color: #999;"
                class="el-icon-arrow-down"
                v-if="!showMoreIcon"
              ></i>
              <i
                style="font-size: 12px; color: #999;"
                class="el-icon-arrow-up"
                v-if="showMoreIcon"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 更多服务 -->
      <div style="position: relative;">
        <div
          class="find-div-body"
          @mouseenter="showMoreIcon = true"
          @mouseleave="showMoreIcon = false"
          v-show="showMoreIcon"
        >
          <MiniApp
            v-for="item in serveListFirst"
            :key="item.id"
            type="recently"
            :name="item.serviceName"
            :data="item"
            :serveUrl="serveUrl"
            openApi
          >
          </MiniApp>
          <div class="find-div-body-s"></div>
        </div>
      </div>
      <div :class="typeShow == 'horizontal' ? 'ServeListS' : 'ServeListA'">
        <!-- 查询 -->
        <div class="ServeList-filter">
          <div class="ServeList-filter-reset">
            <div class="showAll-e">
              <div class="showAll-b">
                <button>
                  <el-checkbox
                    v-model="checked1"
                    style="background-color: transparent;"
                  ></el-checkbox>
                  仅显收藏
                </button>
                <div class="showAll-b-c" v-if="typeShow !== 'horizontal'"></div>
                <div class="selectList">
                  <div v-for="item in labelListIdArr" :key="item">
                    {{ item.labelName
                    }}<i
                      class="el-icon-close"
                      @click="deletedButton(item.id)"
                    ></i>
                  </div>
                </div>

                <button
                  @click="resetCategoryActive"
                  style="color: #084079;"
                  v-if="selectD.length > 0"
                >
                  <i class="el-icon-edit"></i>重置筛选
                </button>
              </div>
            </div>
            <!-- <div>
            共
            <span style='display: inline-block;width: 30px;text-align:center'>{{serveNum}}</span>
            条
          </div> -->
          </div>
          <div class="ServeList-filter-select" style="display: flex;">
            <!-- <z-search
              round
              size="small"
              v-model="searchKeyword"
              placeholder="请输入关键字"
              @clear="handleGetServiceListByLetter1"
              @search="handleGetServiceListByLetter"
            /> -->
            <el-input
              style="
                width: 320px;
                margin-right: 10px;
                border-radius: 16px;
                height: 32px;
              "
              v-model.trim="searchKeyword"
              placeholder="请输入关键字"
              size="small"
              clearable
              @clear="handleGetServiceListByLetter"
              @keyup.enter.native="handleGetServiceListByLetter"
            >
              <i
                style="cursor: pointer;"
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleGetServiceListByLetter"
              ></i>
            </el-input>
            <div class="ServeList-filter-select-s">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item"
                  :value="item.id"
                  :label="'按' + item.taggingName + '显示'"
                >
                </el-option>
              </el-select>
            </div>
            <div
              v-if="typeShow == 'horizontal'"
              style="float: left; margin-top: -12px;"
              @click="switchButton"
            >
              <el-tooltip placement="bottom" content="切换成卡片">
                <el-button type="text" style="height: 50px;">
                  <img
                    style="cursor: pointer;"
                    src="@/assets/Service/hover_list@2x.svg"
                    alt
                    width="30px"
                    height="30px"
                  />
                </el-button>
              </el-tooltip>
            </div>
            <div
              v-else
              style="float: left; margin-top: -12px;"
              @click="switchButton"
            >
              <el-tooltip placement="bottom" content="切换成列表">
                <el-button type="text" style="height: 50px;">
                  <img
                    style="cursor: pointer;"
                    src="@/assets/Service/Switch-2@2x.svg"
                    alt=""
                    width="30px"
                    height="30px"
                  />
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div :class="{ 'ServeList-list': true }">
          <div
            v-if="loadingContent"
            style="
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <i class="el-icon-loading"></i>
          </div>
          <div
            v-for="(agList, index) in showServeListSum"
            :key="index"
            v-if="agList.items.length != 0"
          >
            <div class="ServeList-list-title" style="height: 32px;">
              <span
                >{{
                  agList.labelName +
                  '(' +
                  showlabelName[agList.labelName] +
                  '个)'
                }}
                <div class="span-c"></div>
              </span>
            </div>

            <div
              class="ServeList-list-wrapper"
              :style="{
                'margin-left': typeShow == 'showAll' ? '-30px' : '-13px',
              }"
            >
              <MiniApp
                :style="{
                  'padding-top': '5px',
                  width: typeShow == 'horizontal' ? '20%' : '100/6',
                }"
                class="showHorizontalW"
                size="medium"
                :class="{
                  showApp: typeShow == 'showAll',
                  showHorizontalW: typeShow == 'horizontal',
                }"
                :type="typeShow"
                effect="dark"
                v-for="item in agList.items"
                :data="item"
                :key="item.ID"
                :name="item.serviceName"
                :serveUrl="serveUrl"
                :openApi="openApi"
                :hoverEffect="true"
                :loginUrl="loginUrl"
                :selectheart="checked1"
              ></MiniApp>
            </div>
          </div>
          <div
            style="position: relative; min-height: 300px;"
            v-if="showTagList"
          >
            <div
              style="
                position: absolute;
                left: 50%;
                top: 65px;
                transform: translate(-50%);
              "
            >
              <div>
                <div>
                  <img
                    src="@/assets/Service/noneT@2x.svg"
                    width="160px"
                    height="138px"
                    class="keep-hue"
                  />
                </div>

                <div
                  style="
                    float: left;
                    margin-left: 20px;
                    line-height: 70px;
                    font-size: 20px;
                  "
                >
                  没有相关内容哦
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/serviceNewV2.scss'
import { mapGetters } from 'vuex'
import {
  getRecentListN,
  getServiceTagList,
  getServiceListNV2,
  getCollectionService,
  getRecommendList,
} from '@/api/serviceN'
import MiniApp from './MiniAppNv2'
import configR from '@/configs.js'

/* eslint-disable */
export default {
  name: 'serviceNewV2',
  components: {
    MiniApp,
  },
  computed: {
    ...mapGetters(['token']),
  },
  data() {
    return {
      options: [],
      value: '',
      showTuiF: false,
      showMoreIcon: false,
      showImg: true,
      showListIcon: true,
      loadingContent: false,
      heightSize: '54px',
      serviceTagList1: [
        { id: 0, name: '应用' },
        { id: 1, name: '服务' },
        { id: 2, name: '线上服务' },
      ],
      more1: true,
      searchKeyword: '',
      checked1: false,
      showApp: false,
      showIcon: true,
      heightShow: [],
      showTagList: false,
      loginUrl: `${
        configR.envConfigs.VUE_APP_CAS_URL
      }login?service=${encodeURIComponent(
        configR.envConfigs.VUE_APP_URL
      )}`,
      typeShow: 'showAll',
      openApi: false,
      serveList: [],
      serveListFirst: [],
      checked: {},
      showPublic: true,
      serveListSum: [],
      selectAll: true,
      imgSrc: true,
      selectAllId: [],
      selectD: [],
      serveUrl: configR.envConfigs.PORTAL_API,
      serviceTagList: [],
      categoryActive: [],
      showMore: true,
      serveName: '',
      serveNum: 0,
      listHeight: [],
      listData: [],
      firstListData: [],
      agList: [
        {
          ID: 1,
          serviceName: 'qq',
        },
      ],
      double: false,
      labelListSeletData: [],
      labelListIdS: [],
      labelListIdArr: [],
      showMoreIcon1: true,
      screenWidth: document.body.clientWidth,
      showServeListSum: [],
      showServeListSum1: [],
      showServeListSum2: [],
      contS: 0,
      showlabelName: {},
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.getServiceListNData()
        this.serveListSum = []
        this.showServeListSum = []
        this.showServeListSum1 = []
        this.showServeListSum2 = []
      },
    },
    checked1: {
      handler: function (val) {
        this.getServiceListNData()
        this.serveListSum = []
        this.showServeListSum = []
        this.showServeListSum1 = []
        this.showServeListSum2 = []
      },
      deep: true,
    },
    typeShow: {
      handler: function (val) {
        this.serveListSum = []
        this.showServeListSum = []
        this.showServeListSum1 = []
        this.showServeListSum2 = []
      },
      deep: true,
    },
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        this.screenWidth = newVal
        let list = JSON.parse(JSON.stringify(this.serveList))
        if (this.screenWidth >= 1920) {
          this.serveListFirst = []
        } else if (this.screenWidth >= 1765 && list.length > 9) {
          this.serveListFirst = list.slice(9, 10)
        } else if (this.screenWidth >= 1610 && list.length > 8) {
          this.serveListFirst = list.slice(9, 10)
        } else if (this.screenWidth >= 1455 && list.length > 7) {
          this.serveListFirst = list.slice(8, 10)
        } else if (this.screenWidth >= 1300 && list.length > 6) {
          this.serveListFirst = list.slice(7, 10)
        } else if (this.screenWidth >= 1145 && list.length > 5) {
          this.serveListFirst = list.slice(6, 10)
        } else if (this.screenWidth >= 995 && list.length > 5) {
          this.serveListFirst = list.slice(5, 10)
        }
      },
      deep: true,
    },
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    window.addEventListener('scroll', this.handleScroll, true)
  },
  created() {
    this.serveName =
      configR.envConfigs.NEN_GET_RECOMMES_LIST === '1'
        ? '推荐服务'
        : '最近使用'
    this.getServiceTagListData()
    this.getRecentListData()

    if (!this.token) {
      this.openApi = true
    }
  },

  methods: {
    handleScroll() {
      let scrollTop = document.querySelector('.el-scrollbar__wrap').scrollTop
      var docHeight = document.querySelector('.el-scrollbar__wrap').scrollHeight
      var pageHeight = document.documentElement.clientHeight
      var go = docHeight - scrollTop - pageHeight
      if (go < 300) {
        this.contS++
        this.showServeListSum1.forEach((item) => {
          if (item.pageIndex == this.contS) {
            this.showServeListSum2 = this.showServeListSum2.concat(item)
          }
        })
        for (let i = 1; this.showServeListSum2.length > i; i++) {
          if (
            this.showServeListSum2[i].labelName ==
            this.showServeListSum2[i - 1].labelName
          ) {
            let arr = []
            arr = this.showServeListSum2[i - 1].items
            this.showServeListSum2[i - 1].items = arr.concat(
              this.showServeListSum2[i].items
            )
            this.showServeListSum2.splice(i, 1)
          }
        }
        this.showServeListSum = this.showServeListSum2
      }
    },
    deletedTui() {
      this.showTuiF = true
    },
    //删除指定数组元素
    deletedData(arr, val) {
      var index = arr.indexOf(val)
      if (index > -1) {
        arr.splice(index, 1)
      }
      return arr
    },
    //删出选中标签
    deletedButton(id) {
      for (let k in this.checked) {
        this.checked[k] = this.deletedData(this.checked[k], id)
        if (this.checked[k].length === 0) {
          this.selectAllId.push(k)
        }
      }
      this.deletedData(this.selectD, id)
      this.showServeListSum = []
      this.showServeListSum1 = []
      this.showServeListSum2 = []
      this.getServiceListNData()
    },
    //更多筛选
    moreFilter() {
      if (this.more1) {
        this.heightSize = 'auto'
        if (!this.serviceTagList.length > 0) {
          this.heightSize = '54px'
        }
      } else {
        this.heightSize = this.listHeight[0] + 'px'
      }
      this.more1 = !this.more1
    },

    switchButton() {
      if (this.typeShow == 'horizontal') {
        this.typeShow = 'showAll'
      } else {
        this.typeShow = 'horizontal'
      }
      this.getServiceListNData()
    },
    showAll() {
      if (this.double) {
        this.double = false
      } else {
        this.double = true
      }
    },
    async getServiceTagListData() {
      //获取标签列表
      let data = {
        code: '',
        header: this.openApi ? 'open' : 'portal',
      }
      try {
        let res = await getServiceTagList(data)
        if (res.code == 0) {
          this.options = res.data
          this.serviceTagList = res.data
          this.value = res.data[0].id
          this.serviceTagList.forEach((item) => {
            this.checked[item.id] = []
            this.selectAllId.push(item.id)
            item.labelList.forEach((item1) => {
              this.labelListIdS.push({
                labelName: item1.labelName,
                id: item1.id,
              })
            })
          })
          this.$nextTick(function () {
            this.listHeight = []
            for (let i in this.$refs) {
              this.listHeight.push(this.$refs[i][0].scrollHeight)
            }
            this.heightSize = this.listHeight[0] + 'px'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error',
          })
        }
      } catch (err) {
        this.$message({
          message: '接口报错',
          type: 'error',
        })
      }
    },
    //获取推荐服务
    getRecentListData() {
      if (!configR.envConfigs.NEN_GET_RECOMMES_LIST == '1') {
        let data = {
          header: this.openApi ? 'open' : 'portal',
        }
        getRecommendList(data).then((res) => {
          if (res.code == 0) {
            this.serveList = res.data
            if (this.screenWidth >= 1920) {
              this.serveListFirst = []
            } else if (this.screenWidth >= 1765 && res.data.length > 9) {
              this.serveListFirst = res.data.slice(9, 10)
            } else if (this.screenWidth >= 1610 && res.data.length > 8) {
              this.serveListFirst = res.data.slice(9, 10)
            } else if (this.screenWidth >= 1455 && res.data.length > 7) {
              this.serveListFirst = res.data.slice(8, 10)
            } else if (this.screenWidth >= 1300 && res.data.length > 6) {
              this.serveListFirst = res.data.slice(7, 10)
            } else if (this.screenWidth >= 1145 && res.data.length > 5) {
              this.serveListFirst = res.data.slice(6, 10)
            }
          } else {
            this.$message({
              message: res.message,
              type: 'error',
            })
          }
        })
      } else {
        let data = {
          header: this.openApi ? 'open' : 'portal',
        }
        getRecentListN(data).then((res) => {
          if (res.code == 0) {
            this.serveList = res.data
            if (this.screenWidth >= 1920) {
              this.serveListFirst = []
            } else if (this.screenWidth >= 1765 && res.data.length > 9) {
              this.serveListFirst = res.data.slice(9, 10)
            } else if (this.screenWidth >= 1610 && res.data.length > 8) {
              this.serveListFirst = res.data.slice(9, 10)
            } else if (this.screenWidth >= 1455 && res.data.length > 7) {
              this.serveListFirst = res.data.slice(8, 10)
            } else if (this.screenWidth >= 1300 && res.data.length > 6) {
              this.serveListFirst = res.data.slice(7, 10)
            } else if (this.screenWidth >= 1145 && res.data.length > 5) {
              this.serveListFirst = res.data.slice(6, 10)
            }
          } else {
            this.$message({
              message: res.message,
              type: 'error',
            })
          }
        })
      }
    },

    //获取服务列表
    async getServiceListNData() {
      this.showTagList = false
      this.contS = 0
      if (configR.envConfigs.SCHOOL_CODE == 'qinghaidaxue') {
        this.showPublic = false
      }
      let id = []
      for (let k in this.checked) {
        this.checked[k].forEach((item) => {
          id.push(item)
        })
      }
      this.labelListIdArr = []
      this.labelListIdS.forEach((item) => {
        if (id.indexOf(item.id) !== -1) {
          this.labelListIdArr.push(item)
        }
      })
      let data = {
        keyWord: encodeURIComponent(this.searchKeyword),
        my: this.checked1,
        data: this.checked,
        header: this.openApi ? 'open' : 'portal',
        showPublic: this.showPublic,
        showType: this.value,
      }
      try {
        this.loadingContent = true
        let res = await getServiceListNV2(data)
        if (res.code == 0) {
          this.loadingContent = false
          let serveListSum = res.data
          let serveArr = []
          let serveLabelName = {}
          serveListSum.forEach((element) => {
            serveArr = serveArr.concat(element.items)
            this.showlabelName[element.labelName] = element.items.length
            serveLabelName[element.items[0].labelId] = element.labelName
          })
          let cont = 0
          let items = [serveArr[0]]
          console.log('serveLabelName', serveLabelName)
          let labelNameS = ''
          let cont1 = 0
          for (var i = 1; serveArr.length > i; i++) {
            if (i % 30 == 0) {
              items = []
              cont++
              cont1++
              items.push(serveArr[i])
              labelNameS = serveLabelName[serveArr[i].labelId]
              this.showServeListSum1[cont1] = {
                pageIndex: cont,
                labelName: labelNameS,
                items: items,
              }
            } else if (serveArr[i].labelId != serveArr[i - 1].labelId) {
              if (i == 1) {
                labelNameS = serveLabelName[serveArr[0].labelId]
                this.showServeListSum1[0] = {
                  pageIndex: cont,
                  labelName: labelNameS,
                  items: items,
                }
              }
              cont1++
              items = []
              items.push(serveArr[i])
              labelNameS = serveLabelName[serveArr[i].labelId]
              this.showServeListSum1[cont1] = {
                pageIndex: cont,
                labelName: labelNameS,
                items: items,
              }
            } else {
              items.push(serveArr[i])
              labelNameS = serveLabelName[serveArr[i].labelId]
              this.showServeListSum1[cont1] = {
                pageIndex: cont,
                labelName: labelNameS,
                items: items,
              }
            }
          }
          let conSum = 0
          if (serveArr.length < 30) {
            if (serveArr.length == 1) {
              this.showServeListSum.push({
                items: items,
                pageIndex: 1,
                labelName: serveLabelName[items[0].labelId],
              })
              this.showServeListSum2 = this.showServeListSum
            } else {
              this.showServeListSum = this.showServeListSum1
              this.showServeListSum2 = this.showServeListSum1
            }
          } else {
            for (let i = 0; this.showServeListSum1.length > i; i++) {
              conSum = conSum + this.showServeListSum1[i].items.length
              if (conSum <= 30) {
                this.showServeListSum = this.showServeListSum.concat(
                  this.showServeListSum1[i]
                )
                this.showServeListSum2 = this.showServeListSum
              }
            }
          }
        } else {
          this.loadingContent = false
          this.$message({
            message: res.message,
            type: 'error',
          })
        }
        console.log('this.showServeListSum', this.showServeListSum)

        if (this.showServeListSum.length == 0) {
          this.showTagList = true
        }
      } catch (error) {
        this.loadingContent = false
        this.serveListSum = []
        this.showServeListSum = []
        this.$message({
          message: '接口报错',
          type: 'error',
        })
        this.showTagList = true
      }
    },
    handleCheckAll(id, labelList) {
      labelList.forEach((item) => {
        this.selectD = this.selectD.filter((item1) => {
          return item1 != item.id
        })
      })
      this.selectAllId.push(id)
      this.checked[id] = []
      this.showServeListSum = []
      this.showServeListSum1 = []
      this.showServeListSum2 = []
      this.getServiceListNData()
    },
    handleCheck(id, Pid, valLength) {
      if (this.selectD.indexOf(id) != -1) {
        this.selectD = this.selectD.filter((item) => {
          return item != id
        })
      } else {
        let arr = []
        this.selectD.forEach((item) => {
          if (this.checked[Pid].indexOf(item) == -1) {
            arr.push(item)
          }
        })
        this.selectD = arr
        this.selectD.push(id)
      }
      if (this.checked[Pid].indexOf(id) == -1) {
        this.checked[Pid] = []
        this.checked[Pid].push(id)
      } else {
        this.checked[Pid] = []
      }
      this.selectAllId = this.selectAllId.filter((item) => {
        return item != Pid
      })
      if (this.checked[Pid].length == 0) {
        this.checked[Pid] = []
        this.selectAllId.push(Pid)
      }
      this.showServeListSum = []
      this.showServeListSum1 = []
      this.showServeListSum2 = []
      this.getServiceListNData()
    },
    resetCategoryActive() {
      this.selectD = []
      this.serviceTagList.forEach((item) => {
        this.selectAllId.push(item.id)
      })
      for (let i in this.checked) {
        this.checked[i] = []
      }
      this.showServeListSum = []
      this.showServeListSum1 = []
      this.showServeListSum2 = []
      this.getServiceListNData()
    },
    handleGetServiceListByLetter() {
      this.showServeListSum = []
      this.showServeListSum1 = []
      this.showServeListSum2 = []
      this.getServiceListNData()
    },
    handleGetServiceListByLetter1() {
      this.showServeListSum = []
      this.showServeListSum1 = []
      this.showServeListSum2 = []
    },
  },
}
</script>
